module.exports = __webpack_public_path__ + "images/emoji/sleepy.a667087c4b032de943d8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sleepy.png
// module id = /g+t
// module chunks = 14